var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modal",staticClass:"modal fade",attrs:{"tabindex":"-1","aria-labelledby":"modal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('Login',{attrs:{"show":!!_vm.modal},on:{"closeLoginEvent":_vm.logged,"loading":v => _vm.loading = v}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }